'use client';

import styled from '@emotion/styled';
import { PageRoutes } from '../../../app/pages/domain/constants/PageRoutes';
import ViewButton from '../../../../components/common/button/TextAndButton';
import { Css, ArrowBackIcon, Responsive } from '../../../../ui';

interface IProps {
	pageNumber: number;
	totalPagesNumber: number;
	root?: string;
	queryString?: string;
}

export default function NewsroomPagination({
	pageNumber,
	totalPagesNumber,
	root = PageRoutes.CorporateNewsroomNews,
	queryString = '',
}: IProps) {
	const previousHref = pageNumber === 2 ? root : `${root}/${pageNumber - 1}`;
	const nextHref = `${root}/${pageNumber + 1}`;

	return (
		<Wrapper>
			{totalPagesNumber > 1 && (
				<ViewButton
					href={{ pathname: previousHref, query: queryString }}
					label="Previous page"
					hideLabel
					icon={ArrowBackIcon}
					disabled={pageNumber === 1}
				/>
			)}
			<Text>
				{pageNumber} of {totalPagesNumber || 1}{' '}
				{totalPagesNumber > 1 ? 'pages' : 'page'}
			</Text>
			{pageNumber < totalPagesNumber && (
				<ViewButton
					href={{ pathname: nextHref, query: queryString }}
					label="Next page"
					hideLabel
				/>
			)}
		</Wrapper>
	);
}

const Wrapper = styled.div`
	align-items: center;
	display: flex;
	gap: ${Css.pxToRem(40)};
	justify-content: end;
	margin-bottom: ${Css.pxToRem(40)};
	margin-top: ${Css.pxToRem(40)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		justify-content: space-between;
		margin-bottom: ${Css.pxToRem(90)};
	}
`;

const Text = styled.span``;
